import { Component, Input } from '@angular/core';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';

@Component({
  selector: 'cx-revshare-confirm-component',
  templateUrl: './cx-revshare-confirm.component.html',
  styleUrls: ['./cx-revshare-confirm.component.scss']
})

export class CxRevshareConfirmComponent {

  @Input() data: any;

  constructor(public modalsService: ModalsService, public sharedService: SharedService, public dictionaryService: DictionaryService) { }

  getText() {
    return this.dictionaryService.get('CEDATOX_SUPPLY_REVSHARE_COMMENT_INFO')(this.data.costValue);
  }

  confirm() {
    this.sharedService.sendMessage('CX_REVSHARE_CONFIRM');
    this.modalsService.hideModal();
  }

}
